import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import "../Reports.css";

function AllResourcesReport() {
    const [resources, setResources] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/allResources");
            const resourcesData = response.data.split("\n\n")
                .filter(resource => resource.trim() !== "")
                .map(resource => {
                    const lines = resource.split("\n");
                    const agentId = lines.find(line => line.startsWith("Идентификатор агента: "))?.split(": ")[1];
                    const nameAgent = lines.find(line => line.startsWith("Имя агента: "))?.split(": ")[1];
                    const descriptionAgent = lines.find(line => line.startsWith("Описание агента: "))?.split(": ")[1];
                    const typeAgent = lines.find(line => line.startsWith("Тип агента: "))?.split(": ")[1];
                    const status = lines.find(line => line.startsWith("Статус: "))?.split(": ")[1];

                    if (agentId && nameAgent && typeAgent && status) {
                        return { agentId, nameAgent, descriptionAgent, typeAgent, status };
                    } else {
                        return null;
                    }
                })
                .filter(resource => resource !== null);

            setResources(resourcesData);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по всем ресурсам",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        ...resources.map(resource => [
                            new Paragraph({
                                text: `Идентификатор агента: ${resource.agentId}`,
                            }),
                            new Paragraph({
                                text: `Имя агента: ${resource.nameAgent}`,
                            }),
                            new Paragraph({
                                text: `Описание агента: ${resource.descriptionAgent || "Нет описания"}`,
                            }),
                            new Paragraph({
                                text: `Тип агента: ${resource.typeAgent}`,
                            }),
                            new Paragraph({
                                text: `Статус: ${resource.status}`,
                            }),
                            new Paragraph({
                                text: "",
                            }),
                        ]).flat(),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "all_resources_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>👥 Все ресурсы</h2>

            {resources.length > 0 && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Найдено ресурсов: <span className="otch-highlight">{resources.length}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "📊 Получить все ресурсы"
                    )}
                </button>
                {resources.length > 0 && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>
        </div>
    );
}

export default AllResourcesReport;